import { FaInbox } from '@fareye/utils'
import React from 'react'
import Loader from '../../Loader'
import { Flex } from '../../main'
import { EmptyTable } from '../styled'
import { INoData } from '../types'

function NoData({ colSpan, noDataLoading, style, border }: INoData) {
  var content = <Loader containerStyle={{ boxSizing: 'border-box' }} />
  if (!noDataLoading) {
    const defaultStyle: React.CSSProperties = {
      padding: 55,
    }

    const combinedStyle = { ...defaultStyle, ...style }
    content = (
      <Flex style={combinedStyle} column alignItemsCenter>
        <FaInbox />
        <span>No Data</span>
      </Flex>
    )
  }
  return (
    <EmptyTable data-testid="tbody-nodata">
      <td style= {border} colSpan={colSpan}>{content}</td>
    </EmptyTable>
  )
}

export default NoData
